import { clampTrackGainDb } from '@/shared/track-gain.ts'
import useTracksStore, { MIX_ID } from '../tracks.store.tsx'
import useAudioStore from '../audio.store.tsx'
import { refreshAudioMix } from './refresh-audio-mix.ts'
import { useHistoryStore } from '../history.store.tsx'

export const setTrackVolume = (trackId: string, volume: number): void => {
  const gainDb = clampTrackGainDb(volume)
  const store = useTracksStore.getState()
  if (store.getTrackState(trackId).volume === gainDb) {
    return
  }

  store.setVolume(trackId, gainDb)
  store.setGeneratedMix(undefined)
  useHistoryStore.getState().saveSnapshot()
}

export const updateTrackVolume = async (
  trackId: string,
  volume: number
): Promise<void> => {
  setTrackVolume(trackId, volume)

  if (useAudioStore.getState().currentAudioId !== MIX_ID) return
  await refreshAudioMix(false)
}
